module.exports = __webpack_public_path__ + "static/media/HPS.ac0684c8.png";